import { useCallback } from "react";
import { useAPIAction, UserAccountApi } from "melco-shared-logic";
import { useParams } from "react-router-dom";

export const useUserProductUnassign = () => {

  const { userId } = useParams<{
    userId: string;
  }>();

  const [unassignProducts] = useAPIAction(UserAccountApi,
    async (api, productCode: string) => {


      const data = await api.accountProductsRemoveProductAccess({ productCode });

      return {
        successMessages: [{ message: "default" }],
        data,
      };
    },

    {
      defaultApiConfigOptions: { impersonationForId: userId },
      translationPrefix: "users.products.actions.unassign",



    }
  );

  return useCallback(
    async (productCode: string) => {


      const successfullyUnAssigned: string[] = [];
      try {
        await unassignProducts(productCode);
        successfullyUnAssigned.push(productCode);
      } catch (e) {
        // error handling is already done in useAPIAction
      }
      return successfullyUnAssigned;
    },
    [unassignProducts]
  );
}
